import "katex/dist/katex.min.css";

import Latex from "react-latex-next";
import type { FC } from "react";

import { AnswerPractice } from "components";

import type { IAssignmentResult as IPracticeResult } from "store/slices/topicPractice";

import { generalOptionText } from "utils/formatTextForAnalysis";
import { getTextForSelfEvaluationOption } from "utils/getTextForSelfEvaluationOption";
import { AssignmentPrompt } from "components/AssignmentPrompt";

/* gMrM0Kqx0aR88Z5kYMlK */

interface Props {
  assignmentResult: IPracticeResult;
  toggleModals: (showQuestionAnalysisIndex: number | null) => void;
}

const ViceslovneOdpovedi: FC<Props> = ({ assignmentResult, toggleModals }) => {
  const { assignment } = assignmentResult.assignment;
  if (assignment === undefined || assignment === null) return null;

  const isSelfEvaluation = assignment.scoring?.scoringMethod.scoringMethod === "sebeopravení";

  return (
    <div>
      <AssignmentPrompt assignment={assignment?.assignment} />

      {assignment.assignment?.questions.map((question, qIndex) => (
        <div key={qIndex} className="mt-20px question">
          <Latex>{question.heading ?? ""}</Latex>

          <AnswerPractice
            key={`answer-${qIndex}`}
            index={qIndex}
            assignment={assignment}
            type={assignmentResult.answerVariants?.[qIndex]}
            toggleModals={toggleModals}
            showBackOnSolution={true}
            userAssignmentId={assignmentResult.assignment.id}
          >
            {isSelfEvaluation
              ? getTextForSelfEvaluationOption(assignmentResult?.selfEvalAnswers[qIndex]?.status ?? "danger")
              : generalOptionText(assignmentResult.userAnswers[qIndex])}
          </AnswerPractice>
        </div>
      ))}
    </div>
  );
};

export default ViceslovneOdpovedi;
